import { startCase } from "lodash";
import { FC } from "react";

import { BaseDrawer, CommonDefaultDrawer } from "@ryde/layout";
import {
  DrawerType,
  IDrawerContainerProps,
  IInjectedDrawerProps,
} from "@ryde/shared";

import { MobilFiltersFooterReports } from "./mobile-filters-footer.reports";

export interface IMobileFiltersDrawerReportsProps
  extends IDrawerContainerProps<DrawerType>, IInjectedDrawerProps {
  title: string;
}

export const MobileFiltersDrawerReports: FC<
  IMobileFiltersDrawerReportsProps
> = ({ children, title, onCloseDrawer, drawerNumber }) => {
  return (
    <BaseDrawer onCloseDrawer={onCloseDrawer} drawerNumber={drawerNumber}>
      <CommonDefaultDrawer
        title={startCase(title)}
        onCloseDrawer={onCloseDrawer}
        Footer={<MobilFiltersFooterReports onCloseDrawer={onCloseDrawer} />}
      >
        {children}
      </CommonDefaultDrawer>
    </BaseDrawer>
  );
};
